import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum MessageDirection {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum MessageType {
  INITIAL = "INITIAL",
  REPLY = "REPLY",
}

const marketingMessageSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  conversationId: zExt.objectId(),
  content: z.string(),
  direction: z.enum(MessageDirection),
  type: z.enum(MessageType),
  to: z.string(),
  from: z.string(),
  llmThreadId: zExt.objectId().nullish(),
  draftedAt: z.date().nullish(),
  sentAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const marketingMessageSchema: z.ZodType<MarketingMessage> =
  marketingMessageSchema_;

export interface MarketingMessage
  extends z.infer<typeof marketingMessageSchema_> {}
